const fs = require('fs');
const path = require('path');

function generateVersion(outputDir = 'static') {
  if (typeof window !== 'undefined') {
    // This ensures that fs is never executed on the client-side
    console.log('Skipping fs operation on the client-side');
    return;
  }

  try {
    const version = Date.now().toString();
    const filePath = path.join(outputDir, 'version.txt');

    fs.writeFileSync(filePath, version);
    console.log(`Generated version.txt with version: ${version}`);
  } catch (error) {
    console.error('Error generating version.txt:', error);
  }
}

module.exports = generateVersion;
